import DigitalAgentContent from './DigitalAgentContent';
export default DigitalAgentContent;